var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWork = function SvgWork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612.002 612.002",
    style: {
      enableBackground: "new 0 0 612.002 612.002"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M361.456,308.393c0.035,0.457,0.068,0.909,0.068,1.375v19.939c0,10.077-8.162,18.235-18.235,18.235h-74.582    c-10.073,0-18.235-8.158-18.235-18.235v-19.939c0-0.466,0.035-0.92,0.07-1.375L0,244.126V536.35    c0,8.891,7.204,16.097,16.095,16.097h49.542v13.88c0,1.932,1.567,3.494,3.498,3.494h41.666c1.929,0,3.494-1.562,3.494-3.494    v-13.88h383.407v13.88c0,1.932,1.564,3.494,3.494,3.494h41.666c1.929,0,3.495-1.562,3.495-3.494v-13.88h49.545    c8.888,0,16.099-7.205,16.099-16.097V244.126L361.456,308.393z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.001,289.385l306.001-78.491v-74.87c0-8.89-7.211-16.093-16.099-16.093h-178.85V62.814    c0-11.394-9.239-20.633-20.635-20.633H215.577c-11.393,0-20.632,9.239-20.632,20.633v57.117H16.095    C7.204,119.931,0,127.134,0,136.024v74.872L306.001,289.385z M240.01,87.245h131.977v32.686H240.01V87.245z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#7E7E7E"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/work.56a0d3c1.svg";
export { ForwardRef as ReactComponent };